import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('embargo', '/embargoes')
const actions = generator.generate()

export default actions
